import { render, staticRenderFns } from "./WidgetColumnType.vue?vue&type=template&id=42a97e42"
import script from "./WidgetColumnType.vue?vue&type=script&lang=js"
export * from "./WidgetColumnType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports